<template>
  <div class="nft-detail-page">
    <div class="nft-header">
      <div class="d-flex gap3 align-items-center">
        <div class="btn-back" @click="goBack">
          <img src="../assets/arrow-left.svg" alt="Arrow Left" />
        </div>
        <div class="title ms-3">{{ $t("dashboard.nft.details.title") }}</div>
      </div>
      <div class="mint-btn" @click="mintThis">
        <span>{{ $t("nft.detail.mint") }}</span>
      </div>
    </div>
    <div class="d-block d-md-flex justify-content-between gap-4">
      <div class="nft-preview">
        <span class="preview">{{ $t("dashboard.nft.details.preview") }}</span>
        <img :src="this.nftObj.image" alt="NFT Image" />
        <span class="id">
          {{ nftObj.id }}
        </span>
      </div>
      <div class="nft-info">
        <h3 class="color-gold">
          {{ nftObj.id }}
        </h3>
<!--        <p>-->
<!--          {{-->
<!--            $t("dashboard.nft.details.createdAt", {-->
<!--              date: this.nftObj.createdAt,-->
<!--              creator: this.nftObj.creator,-->
<!--            })-->
<!--          }}-->
<!--        </p>-->
        <div class="item">
          <p>{{ $t("dashboard.nft.details.category") }}</p>
          <p>{{ nftObj.category }}</p>
        </div>
        <div class="item">
          <p>{{ $t("dashboard.nft.details.stage") }}</p>
          <p>{{ nftObj.stage }}</p>
        </div>
        <div class="item">
          <p>{{ $t("dashboard.nft.details.address") }}</p>
          <p>{{ nftObj.address }}</p>
        </div>
        <div class="item">
          <p>{{ $t("dashboard.nft.details.qualification") }}</p>
          <p>{{ nftObj.qualification }}</p>
        </div>
        <div class="d-flex w-100">
          <div class="item w-50">
            <p>{{ $t("dashboard.nft.details.status") }}</p>
            <p :class="nftObj.status == 'For Sale' ? 'for-sale' : 'hold'">
              {{ nftObj.status }}
            </p>
          </div>
          <div class="item w-50">
            <p>{{ $t("dashboard.nft.details.price") }}</p>
            <p>{{ nftObj.price }} ETH</p>
          </div>
        </div>
      </div>
    </div>
    <hr />

<!--    <div class="d-flex w-100">-->
<!--      <div class="item w-50">-->
<!--        <p>{{ $t("dashboard.nft.details.other") }}</p>-->
<!--        <p>{{ nftObj.other.details }}</p>-->
<!--      </div>-->
<!--      <div class="item w-50">-->
<!--        <p>{{ $t("dashboard.nft.details.category") }}</p>-->
<!--        <p>{{ nftObj.other.category }}</p>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="item">-->
<!--      <p>{{ $t("dashboard.nft.details.address") }}</p>-->
<!--      <p>{{ nftObj.other.address }}</p>-->
<!--    </div>-->
<!--    <div class="item">-->
<!--      <p>{{ $t("dashboard.nft.details.qualification") }}</p>-->
<!--      <p>{{ nftObj.other.description }}</p>-->
<!--    </div>-->
    <b-modal
      id="nft-purchased"
      ref="nft-purchased"
      hide-footer
      centered
      :title="$t('nft.detail.purchased', { type: nftType })"
    >
    <div class="w-100 px-5 py-3">
        <img :src="nftObj.image" alt="NFT Image" class="w-100" />
    </div>
    </b-modal>

  </div>
</template>

<script>
import { BModal } from "bootstrap-vue";
//import { nfts } from '../plugins/nfts'
import {getNftSign, userTest} from "@/network/api";
import {Toast} from "vant";
import {nfts} from "@/plugins/nfts";
import {parseEther} from "viem";

export default {
  props: {
    nft:Object
  },
  components: {
    BModal,
  },
  data() {
    return {

      nftObj: {
        id: null,
        name: "",
        image: "",
        createdAt: "",
        creator: "",
        category: "",
        stage:"",
        address: "",
        description: "",
        qualification:"",
        status: "",
        price: 0,
        other: {
          details: "",
          category: "",
          address: "",
          description: "",
        },
      },
      nftType: "",


    };
  },
  mounted() {
    console.log(this.$route.query)
    this.getData();
  },
  methods: {
    getData() {
      let nft = this.nft;
      this.nftObj = {
        id: nft.id,
        name: nft.name,
        image: nft.image,
        category:nft.category,
        stage:"Whitelist",
        address:process.env.VUE_APP_NFT_CONTRACT_ADDRESS,
        qualification:"10 Referrals",
        status:nft.status=="1"?"For Sale":"Hold",
        price: "0.01"
      };
      //return
      // eslint-disable-next-line no-unreachable
      // if (!this.nftID) {
      //   this.goBack();
      // }
      // if (this.nftID.includes("GSG") || this.nftID.includes("gsg"))
      //   this.nftType = "GSG";
      // if (this.nftID.includes("GEMA") || this.nftID.includes("gema"))
      //   this.nftType = "GEMA";
      // // 调用API获取NFT信息
      // this.nftObj = {
      //   id: this.nftID,
      //   name: this.nftID,
      //   image: "/images/nft/GSG-00032.png",
      //   createdAt: "16-08-2024 03:33",
      //   creator: "me",
      //   category: "GSG Token",
      //   address: "0x485809bx3e6082Ac554088C94",
      //   description: "Description of Token here",
      //   status: "For Sale",
      //   price: 5.5,
      //   other: {
      //     details: "Detail 1",
      //     category: "GSG Token",
      //     address: "0x485809bx3e6082Ac554088C94",
      //     description: "Description of Token here",
      //   },
      // };
    },
    goBack() {
      this.$emit("goBack");
    },
    async mintThis() {
      // let r = await getNftSign({
      //     type: "1,2",
      //     address,
      //     id: "100005"
      // });


      this.$emit("toggleIfr");
      // let info = await getNftSign({
      //   type:"1,2",
      //   address:"0x50AA0B6a2beDbfC58f6B8C81d54cBD306d330262",
      //   id:"100001"
      // });
      // return;


      // let res = await nfts.writeContract({
      //   "value":"0.01",
      //   "message":"0xd2135CfB216b74109775236E36d4b433F1DF507B",
      //   "signature":"0xA0Cf798816D4b9b9866b5330EEa46a18382f251e"}
      // );
      //console.log(res)
      // eslint-disable-next-line no-unreachable
//-----------------------
//       let res = await nfts.writeContract(async (address) => {
//         let r = await getNftSign({
//           type: "1,2",
//           address,
//           id: "100005"
//         });
//         return r.data;
//       });
//       console.log(res);
//       const url = 'https://example.com/api';
//       const iframe = document.createElement('iframe');
//       iframe.src = url;
//       document.body.appendChild(iframe);
//
//       const win = iframe.contentWindow;

//-----------------------
      //console.log(res);
      // let res1 = await userTest();
      // console.log(res1)
      // Toast.fail("1123");
      //this.$refs["nft-connect"].show();
      //this.$refs["nft-purchased"].show();
    },
  },
  watch: {
    "$i18n.locale": function () {
      this.getData();
    },
  },
};
</script>

<style>
.nft-detail-page {
  .btn-back {
    border: 1px solid #e1e8ed;
    border-radius: 10px;
    width: 56px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #687b8e;
    img {
      margin: 0;
      width: unset;
    }
  }
  .mint-btn {
    height: 50px;
    padding: 0.5rem 1rem;
    border-radius: 1.5rem;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: linear-gradient(to right, #06a5ff, #3dde91);
    align-self: center;
  }
  .nft-preview {
    position: relative;
    border: 1px solid #e1e8ed;
    border-radius: 1.25rem;
    box-sizing: border-box;
    padding: 3rem 1rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .preview {
      position: absolute;
      top: 1rem;
      left: 1rem;
    }
    img {
      width: 90%;
    }
    .id {
      position: absolute;
      bottom: 1rem;
      left: 1rem;
    }
  }
  .nft-info {
    width: 100%;
    padding: 0;
    margin-top: 2rem;
    box-sizing: border-box;
  }
  .item {
    margin-top: 1rem;
    p {
      margin-bottom: 0.3rem;
    }
    p:first-of-type {
      font-weight: 700;
    }
  }

  .for-sale,
  .hold {
    background-color: #3ab74e;
    padding: 0.3rem 1rem;
    color: white;
    font-size: 0.8rem;
    border-radius: 0.8rem;
    display: block;
    text-align: center;
    width: fit-content;
  }
  .for-sale {
    background-color: #3ab74e;
  }
  .hold {
    background-color: #ffb803;
  }
}
#nft-purchased.modal.show,#nft-connect.modal.show {
  .modal-dialog {
    .modal-content {
      .modal-header {
        justify-content: space-between;
        .close {
          border: none;
          background-color: transparent;
          font-weight: 800;
          font-size: 30px;
          line-height: 20px;
          vertical-align: middle;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 0 3px 6px;
        }
      }
    }
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .nft-preview {
    width: 40%;
  }
  .nft-info {
    width: 60%;
    padding: 2rem;
    margin: 0;
  }
}
</style>
